export const LEASE_UPLOADED = 'LEASE_UPLOADED';
export const LEASE_EXECUTED = 'LEASE_EXECUTED';
export const LEASE_CANCELLED = 'LEASE_CANCELLED';
export const VOUCHERS_UPDATED = 'VOUCHERS_UPDATED';
